import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const CircleRemoveIcon = createSvgIcon(
  <>
    <title>circle remove</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      transform="translate(0.5 0.5)"
    >
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="22"
        x2="10"
        y1="10"
        y2="22"
      />{' '}
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="22"
        x2="10"
        y1="22"
        y2="10"
      />{' '}
      <circle
        cx="16"
        cy="16"
        fill="none"
        r="14"
        stroke="#222222"
        strokeMiterlimit="10"
      />
    </g>
  </>
)
